export default function InitAnchorLinks() {
    const hash = window.location.hash
    const headerHeight = 133 // todo read dynamic height
    const mobileHeaderHeight = 71 // todo read dynamic height

    function getHeaderOffset(): number {
        return window.matchMedia('only screen and (max-width: 760px)').matches
            ? mobileHeaderHeight
            : headerHeight
    }

    function scrollToTarget(target: Element): void {
        const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset()
        window.scrollTo({ top, behavior: 'smooth' })
    }

    // set offset to anchor because of sticky nav
    if (hash) {
        const target = document.querySelector(hash)
        if (target) scrollToTarget(target)
    }

    // scroll to anchor if on same page
    document.addEventListener('click', (event: MouseEvent) => {
        const link = (event.target as Element).closest('a[href^="#"]') as HTMLAnchorElement | null
        if (!link) return
        const href = link.getAttribute('href')
        if (!href) return
        const target = document.querySelector(href)
        if (!target) return
        event.preventDefault()
        scrollToTarget(target)
    })
}
